import { FaqNodeSearchByIds } from '@mygpt/app';

export type MsgCitation = {
  title: string;
  val: string;
  type: string;
}[];

export interface FAQsPropertyInfo {
  id: string;
  value: string;
}

export interface MessageMetaData {
  created_at: string;
  deleted_at: string | null;
  updated_at: string;
  id: string;
  key: string;
  session_message_id: string;
  value: string;
}

export type ratingType = 2 | -1; // 2点赞 -1踩

export interface SessionInfo {
  session_id: string;
  title: string;
  is_test: boolean;
  created_by: string;
  created_ip: string;
  user_del: boolean;
  source: string;
  robot_id: string;
  user_identifier: string;
  transfer_to_human: boolean;
}
export interface MessageDetailInfo {
  answer: string;
  created_at: string;
  id: string;
  faq_id: string | null;
  default_dataset_id: string;
  question: string;
  session_id: string;
  total_tokens: number;
  user_id: string;
  rating: ratingType;
  anonymous_username: string | null;
  footnotes?: Footnote[];
  sources: string | null;
  property_info: FAQsPropertyInfo[];
  reference_list?: Footnote[];
  reference_indexes?: ReferenceSign[];
  citation?: MsgCitation;
  session_message_metadata?: MessageMetaData[];
  /** 来源页面 URL（widget 嵌入页面地址，消息级字段） */
  url?: string | null;
  feedback_content?: string;
  session: SessionInfo;
  is_correct: boolean;
  llm_can_answer: boolean;
  comes_from: string;
  // 是否通过表单反馈过
  transfer_to_human: boolean;
  tags: Array<{
    id: string;
    name: string;
    group: {
      id: string;
      name: string;
    };
  }>;
}

export interface Footnote {
  id: string;
  file_id: string | null;
  index: number;
  source: string;
  title: string;
  page_numbers: number[];
  url?: string; // URL for web page citations, opens in new tab when clicked
}

export interface ReferenceSign {
  id: string;
  title?: string;
  sentences: string[];
}

export interface ReferenceContent {
  file_id: string;
  source: string;
  texts?: string[];
  pages?: number[];
}

export interface RecommendList {
  name: string;
  id: string;
  language: string;
}

export interface FaqChildNode {
  name: string;
  id: string;
  language: string;
}

export type QuestionType = 'simple' | 'detail';

export interface PageInfo {
  url: string;
  title: string;
  source?: 'widget' | 'playground' | 'share';
}

export interface SessionListItem {
  messages: SessionListParam[];
  footnotes?: Footnote[];
  reference_list?: Footnote[];
  reference_indexes?: ReferenceSign[];
  pending?: string;
  recommend_list?: RecommendList[];
  faq_child_node?: FaqChildNode[];
  llm_can_answer?: boolean;
  clarification?: ClarificationType;
}

// 根据不同的类型，展示不同的错误信息、交互：
// 'api_error' 接口错误
// 'user_canceled' 用户取消
// 'network_error' 网络错误
// 'unknown_error' 未知错误
// 'permission_limit' 权限限制
export enum ERROR_TYPE {
  API_ERROR = 'api_error',
  USER_CANCELED = 'user_canceled',
  NETWORK_ERROR = 'network_error',
  UNKNOWN_ERROR = 'unknown_error',
  PERMISSION_LIMIT = 'permission_limit',
}

export interface SessionListParam {
  isAnswer: boolean;
  text: string;
  prompt?: string;
  error?: string;
  error_type?: ERROR_TYPE;
  // 错误气泡对应的用户提问，供「再生成」按钮使用
  question?: string;
  source?: string[];
  rating?: number;
  messageId?: string;
  status?: number;
  footnotes?: Footnote[];
  reference_list?: Footnote[];
  reference_indexes?: ReferenceSign[];
  recommend_list?: RecommendList[];
  faq_child_node?: FaqChildNode[];
  userAborted?: boolean; // 是否用户主动终止回答
  llm_can_answer?: boolean;
  // 消息的预览组件里使用的 iframe url
  canvas_url?: string;
  canvas_title?: string;
  clarification?: ClarificationType;
  // 推荐消息，用于初始消息中显示推荐问题
  suggestedMessages?: string[] | FaqNodeSearchByIds[];
  // 请求追踪 ID，来自响应头 x-request-id
  traceId?: string;
}

// 澄清类型
// nonclarification - 非澄清
// other - 其他澄清
// phone - 电话号码澄清
// email - 邮件澄清
export type ClarificationType = 'nonclarification' | 'other' | 'phone' | 'email';

// 聊天模式
export type ChatMode = 'text' | 'voice' | 'realtime';
